import axios from "axios";
import { ADMIN_API } from "../../config";

/**
 * Récupère la liste des utilisateurs.
 */
function getUsers() {
  return axios.get(`${ADMIN_API}/users`).then((response) => response.data);
}

/**
 * Récupère les informations d'un utilisateur défini par son ID.
 *
 * @param {number|string} id - L'identifiant de l'utilisateur.
 * @returns {Promise<Object>} - Les données de l'utilisateur.
 */
function getUserById(id) {
  return axios
    .get(`${ADMIN_API}/fetchUserById/${id}`)
    .then((response) => response.data);
}

const api = {
  getUsers,
  getUserById,
};

export default api;
